import { isDev } from './is-node-environment.js';

/**
 * Logs the given message as a warning, if we are in developer mode.
 * Does nothing otherwise.
 *
 * @param log - main part of the log message.
 * @param details - passed as second parameter to the console warn.
 */
export function devLog(log: string, details?: unknown): void {
  if (isDev()) {
    if (details) {
      // oxlint-disable-next-line no-console
      console.warn(log, details);
      return;
    }
    // oxlint-disable-next-line no-console
    console.warn(log);
  }
}
